module.exports = __webpack_public_path__ + "static/thebit-0a79cb4037652f67e774e64eafae9a64.jpg";